import './Dashboard.css';
import { useNavigate } from 'react-router-dom';
import { useAuthorization, logoutUser } from '../../Utils/AuthUtils.js';
import { useMemo, useState, useEffect } from 'react';
import Questions from './Questions/Questions.js';
import Clients from './Clients/Clients.js';
import Returns from './Returns/Returns.js';


const VIEWS = [
    {
        id: 'questions',
        title: 'Questions',
        component: Questions,
    },
    {
        id: 'clients',
        title: 'Clients',
        component: Clients,
    },
    {
        id: 'returns',
        title: 'Returns',
        component: Returns,
    },
];
const DEFAULT_VIEW = VIEWS[0];

function Dashboard() {
    const { authInfo, loading } = useAuthorization();
    const navigate = useNavigate();

    const [view, setView] = useState(DEFAULT_VIEW);
    const [toggleNav, setToggleNav] = useState(true);

    const logout = () => {
        logoutUser(navigate);
    }

    useEffect(() => {
        if (!loading && !authInfo) {
            navigate('/login');
        }
    }, [authInfo, loading, navigate]);

    const renderView = useMemo(() => {
        const View = view.component;
        return <View key={view.id} toggleNav={toggleNav} />
    }, [view.id, toggleNav]);

    if (loading) {
        return <div className="Dashboard-loading">Loading...</div>;
    }

    if (!authInfo) {
        return null;
    }




    return (
        <div className="Dashboard">
            <div className="dashboard-header">
                <div className="nav-toggle" onClick={() => setToggleNav(!toggleNav)}>
                    {toggleNav ? '✕' : '☰'}
                </div>
                <div className="welcome-text">
                    {authInfo?.user?.display_name}
                </div>
                <div className="logout-link" onClick={() => logout()}>
                    Logout
                </div>
            </div>
            {toggleNav && (
                <div className="nav-container">
                    {VIEWS.map((v) => (
                        <div
                            key={v.id}
                            className={`nav-link ${view.id === v.id ? 'active' : ''}`}
                            onClick={() => setView(v)}
                        >
                            {v.title}
                        </div>
                    ))}
                </div>
            )}
            {renderView}
        </div>
    );
}

export default Dashboard;
